import React from 'react';
import { useParadigm } from '../../contexts/ParadigmContext';
import EATravelGuide from './EATravelGuide';
import SpeakerBureauGuide from './SpeakerBureauGuide';

/** Selects onboarding content for the organization currently being viewed. */
export default function GettingStartedGuide() {
  const { isSpeakerBureau } = useParadigm();
  return isSpeakerBureau ? <SpeakerBureauGuide /> : <EATravelGuide />;
}
